/* eslint-disable max-len */
import React, { useState } from 'react'
import { List } from 'Lib/List'

import { supportByTripId } from '../../pages/Trips/trips.helper'
import useModal from '../../newComponents/SupportPage/useModal'

import { Login } from '../../newComponents/Login'

const LoginPage = props => {
  const { isPWA } = props
  const { isShowing, toggle } = useModal()
  const [tripId, setTripId] = useState(null)
  const [page, setPageName] = useState(null)
  const [otp, setOTP] = useState(null)
  const [otpReceived, setOTPReceived] = useState(false)
  const [snackMsg, setSnackMsg] = useState(null)

  const textHandler = (e, name) => {
    if (name === 'tripId') {
      setTripId(e.target.value)
    }
    if (name === 'otp') {
      setOTP(e.target.value)
    }
  }

  const resetHandler = e => {
    setTripId(null)
    setOTP(null)
    setOTPReceived(false)
    setSnackMsg(null)
  }

  const handleIsShowing = () => {
    setPageName('SIGNIN')
    toggle()
  }

  const btnHandler = (e, action) => {
    if (action.toLowerCase() === 'get otp') {
      setOTP(null)
      supportByTripId(tripId).then(resp => {
        if (resp && resp.status === 200 && resp.smsResponse.status.toLowerCase() === 'success') {
          setOTPReceived(true)
          setSnackMsg('OTP has been sent to your mobile number and will expire in 3 mins.')
        } else if (resp && resp.status === 404) {
          setOTPReceived(true)
          setSnackMsg('Please enter a valid Trip Id to get the OTP.')
        }
      })
    } else if (action.toLowerCase() === 'fetch trip') {
      supportByTripId(tripId, otp).then(resp => {
        if (resp && resp.status === 200 && resp.message.toLowerCase() === 'verified') {
          window.location.href = `/accounts/trips/${tripId}`
        } else if (resp.status === 404) {
          setSnackMsg('Incorrect OTP entry. Please try again, or tap "Resend OTP" for a new OTP')
        } else if (resp.status === 401) {
          setSnackMsg('You exceeded the OTP validation limit. Please try again in 10 minutes.')
        } else if (resp.status === 500) {
          setSnackMsg('Something went wrong. Please Try Again')
        }
      })
    }
  }

  const signHandle = e => {
    setPageName('SIGNIN')
    toggle()
  }

  const loginList = (
    <List className="">
      <div className={`leftWidget ba bc-grey bg-white ${isPWA ? 'px-4' : 'px40'} py30 min-hight`}>
        <p className="fs-8 fSemiBold lh28 fw-600">
          Help us find your trip
        </p>
        <p className="lh20 f3 c-neutral-700 pt-5">
          {'Please provide your Trip ID to proceed'}
        </p>
        <div className="pt30" />
        <div className={`${isPWA ? '' : 'flex flex-middle'}`}>
          <span className="fSemiBold f3 c-neutral-900 inputLabel">Trip ID</span>
          <div className={`${isPWA && 'pt-3'} p-relative`}>
            <input
              className="inputBox ba bc-grey"
              value={tripId || ''}
              onChange={e => textHandler(e, 'tripId')}
              placeholder="Enter Trip ID"
            />
            <span
              className={`${isPWA && 'pt-3 px-12'} insideButton p-absolute`}
              onClick={e => {
                resetHandler(e)
              }}
            >
              Change
            </span>
          </div>
        </div>
        <div className="pt5" />
        <div className="pt-4" />
        <div className={`${isPWA ? '' : 'flex flex-middle'}`}>
          <span className="fSemiBold f3 c-neutral-900 inputLabel">6 digit OTP</span>
          <div className={`${isPWA && 'pt-3'} p-relative`}>
            <input
              className="inputBox ba bc-grey"
              value={otp || ''}
              onChange={e => textHandler(e, 'otp')}
              maxLength="6"
              type="number"
              disabled={!otpReceived}
              placeholder="Enter the OTP received"
            />
            {otpReceived && (
              <span className={`${isPWA && 'px-12 pt-3'} insideButton p-absolute`} onClick={e => btnHandler(e, 'Get OTP')}>
                Resend OTP
              </span>
            )}
          </div>
          <div className={`${isPWA && 'pb-4'} pl13`} />
          <button
            type="submit"
            className="submitButton"
            disabled={tripId === null || (otpReceived && otp === null)}
            onClick={e => {
              btnHandler(e, otpReceived ? 'Fetch Trip' : 'Get OTP')
            }}
          >
            {otpReceived ? 'Fetch Trip' : 'Get OTP'}
          </button>
        </div>
        <div className="pt10" />
        <div className={`${isPWA ? '' : 'flex flex-middle'}`}>
          <span className="fSemiBold f3 c-neutral-900 inputLabel" />
          {otpReceived && (
            <div className="p-relative">
              <p style={{ maxWidth: '288px', color: '#666666', fontSize: '12px' }}>{snackMsg}</p>
            </div>
          )}
        </div>
        <div className="pt30" />
        <div className="pt10" />
        <p className="c-neutral-700 f3" onClick={e => signHandle(e)}>
          Have an account? <span style={{ color: '#005FDB' }}>Sign in</span> to fetch your trips
        </p>
      </div>
    </List>
  )

  return (
    <React.Fragment>{loginList}
      <If condition={page}>
        <Login
          page={page}
          isShowing={isShowing}
          toggle={toggle}
          handleIsShowing={handleIsShowing}
        />
      </If>
    </React.Fragment>
  )
}

export default LoginPage
